import {Component, Input} from '@angular/core';
import {UtilService} from "../../../../services/util/util.service";
import {CartAdvancedInterface} from '../../../../services/cart/cart.interface';
import {Privileges} from '../../../admin/privileges/privileges.constants';
import {CentrePropertyService} from "../../../../services/centre-property/centre-property.service";
import {AuthService} from "../../../../services/auth/auth.service";

@Component({
  selector: 'app-cart-totals',
  templateUrl: './cart-totals.component.html',
  styleUrls: ['./cart-totals.component.scss']
})
export class CartTotalsComponent<Type> {
  @Input() cartService: CartAdvancedInterface<Type>;

  public isCompact = true;
  public Privileges = Privileges;

  constructor(public authService: AuthService,
              public centrePropertyService: CentrePropertyService,
              public utilService: UtilService) {}

  get canExpandCombinedFees(): boolean {
    return this.cartService.hasMultipleFees && this.centrePropertyService.isEnabled('exclude_own_fees');
  }
}
